import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { RETAILER_PRODUCTS_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { clearRetailerProductsSignals, mapDrawerProduct } from "./@signals"
import { useRetailerProducts } from "./@hooks"
import RetailerProductsFilters from "./Filters"
import RetailerProductsTable from "./Table"
import StatsCards from "./StatsCards"
import MapDrawer from "./MapDrawer"
import MatchCompareModal from "./MatchCompareModal"


export default function RetailerProductsPage() {
    useRetailerProducts()

    useEffect(() => {
        return clearRetailerProductsSignals
    }, [])

    return <PageWrapper
        head={RETAILER_PRODUCTS_ROUTES.TITLE}
        title={RETAILER_PRODUCTS_ROUTES.TITLE}
        subtitle={RETAILER_PRODUCTS_ROUTES.SUBTITLE}
        actions={null}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <RetailerProductsFilters />
            </Grid>

            <Grid item xs={12}>
                <StatsCards />
                <RetailerProductsTable />
            </Grid>
        </Grid>

        <MapDrawer
            open={!!mapDrawerProduct.value}
            onClose={() => mapDrawerProduct.value = null}
            product={mapDrawerProduct.value}
        />
        <MatchCompareModal />
    </PageWrapper>
}
